
import { defineComponent } from 'vue'

const LoaderComponent = defineComponent({
  props: {
    loaderType: {
      type: String,
      required: true,
      // type: on vuetify doc
      default: 'list-item@8'
    }
  }
})
export default LoaderComponent
